import { get } from "../https";

const SERVER_URL = process.env.REACT_APP_HIRE_SIDE_API;

export const getUsers = (email, password) => {
  let params = {};

  return get(SERVER_URL, null, params);
};
